import { Edge, getOutgoers, Node } from 'reactflow'

// Get the chain of nodes from the given node to leaf node
export const getNodeChain = ({
  currentNode,
  chain = [],
  nodes,
  edges,
}: {
  currentNode: Node
  chain?: Node[]
  nodes: Node[]
  edges: Edge[]
}) => {
  chain.push(currentNode)

  const outgoers = getOutgoers(currentNode, nodes, edges)

  outgoers.forEach((outgoer) => {
    getNodeChain({ currentNode: outgoer, chain, nodes, edges })
  })

  return chain
}
